import { useStaticQuery, graphql } from 'gatsby';
import { ISlideImage } from 'src/molecules/Standard/Shared/ImageSlideWithProgress/ImageSlideWithProgress';
import { IStaticContentfulImages } from 'src/types/contentful';

const useTapIntoMagicSlides = (): ISlideImage[] => {
  const { showCase1, showCase2, showCase3 } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      showCase1: contentfulAsset(contentful_id: { eq: "rQesbqTGse2PjBFZ9nRu7" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      showCase2: contentfulAsset(contentful_id: { eq: "1E37rKJKgLJVsZa2dTW6dS" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      showCase3: contentfulAsset(contentful_id: { eq: "7hl4mFaU0xBFcaKnuO9AWn" }) {
        gatsbyImageData(width: 2300, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  return [
    {
      image: showCase1.gatsbyImageData,
      title: 'People magic introduces your members to each other',
      description:
        'Say goodbye to rarely visited introduction channels. People magic is AI that surfaces and filters members in a beautiful, wildly engaging interface.',
    },
    {
      image: showCase2.gatsbyImageData,
      title: 'People magic uses profiles to  create true community quickly',
      description:
        'People magic uses AI to cluster the most relevant members to each other and show similarities—making every member profile a place to discover new people. ',
    },
    {
      image: showCase3.gatsbyImageData,
      title: 'People may come for your content, but they stay for other members',
      description:
        'Numbers don’t lie. With people magic, your online courses, content, memberships, challenges, and events  become much more engaging and profitable.',
    },
  ];
};

export default useTapIntoMagicSlides;
